import _extends from 'babel-runtime/helpers/extends';

import { mapGetters } from 'vuex';
import { Navbar, Sidebar, AppMain } from './components';
import AddProject from '@/views/pm/components/AddProject';
import ProjectBoard from '@/views/pm/project/ProjectBoard';
import TagBoard from '@/views/pm/tag/TagBoard';

export default {
  name: 'PmLayout',
  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain,
    AddProject: AddProject,
    ProjectBoard: ProjectBoard,
    TagBoard: TagBoard
  },
  data: function data() {
    return {
      isCreate: false,
      projectBoardShow: false,
      tagBoardShow: false
    };
  },

  computed: _extends({}, mapGetters(['project', 'projectRouters']), {
    permissonProject: function permissonProject() {
      return this.project && this.project.projectManage && this.project.projectManage.save;
    }
  }),
  created: function created() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    navClick: function navClick(index) {},
    siderbarSelect: function siderbarSelect(key, keyPath) {
      if (key == '/project-list/index') {
        this.tagBoardShow = false;
        this.projectBoardShow = true;
      } else if (key == '/tag-list/index') {
        this.projectBoardShow = false;
        this.tagBoardShow = true;
      } else {
        this.projectBoardShow = false;
        this.tagBoardShow = false;
      }
    },
    quicklyCreate: function quicklyCreate() {
      this.projectBoardShow = false;
      this.tagBoardShow = false;
      this.isCreate = true;
    }
  }
};